// 全屏模块
<template>
  <div class="DkbFScreen">
    <!-- 全屏标题 -->
    <p class="fsTit">{{data.title}}</p>
    <!-- 全屏按钮 -->
    <span class="fsBtn" @click="settingSS" v-if="!$route.meta.LSS"></span>
    <!-- 全屏内容组件 -->
    <NARA class="fsContent" v-if="(!$route.params.content && $route.params.name === 'NARA') || $route.meta.LSS "></NARA>
    <MR class="fsContent" v-if="$route.params.name === 'MR'"></MR>
    <Access class="fsContent" v-if="$route.params.name === 'Access'"></Access>
    <Cabinet class="fsContent" v-if="$route.params.name === 'Cabinet'"></Cabinet>
    <Map class="fsContent" v-if="$route.params.name === 'Map'"></Map>
    <Humiture class="fsContent" v-if="$route.params.name === 'Humiture'"></Humiture>
  </div>
</template>

<script>
  // import NARA from '@/components/DkbPage/FScreen/NARA'      // 档案馆
  import NARA from '@/components/DkbPage/FScreen/NARA/NARA'      // 档案馆（华能）
  import MR from '@/components/DkbPage/FScreen/MR'               // 会议室
  import Access from '@/components/DkbPage/FScreen/Access'       // 门禁
  import Cabinet from '@/components/DkbPage/FScreen/Cabinet'     // 柜体总体数据
  import Map from '@/components/DkbPage/FScreen/Map'             // 地图
  import Humiture from '@/components/DkbPage/FScreen/Humiture'   // 温湿度
  let vm

  export default {
    name: 'DkbFScreen',
    components: {
      NARA,
      MR,
      Access,
      Cabinet,
      Map,
      Humiture
    },
    data () {
      return {
        data: {
          title: ''
        }
      }
    },
    created () {
      vm = this
      console.log('route', this.$route)
      vm.getTitle()
    },
    mounted() {
    },
    computed: {
    },
    methods: {
      getTitle() {
        let name = vm.$route.params.name
        let LSS = vm.$route.meta.LSS
        vm.data.title = 
        name === 'NARA' || LSS ? '档案馆' : 
        name === 'MR' ? '会议室' : 
        name === 'Access' ? '门禁' : 
        name === 'Cabinet' ? '柜类整体数据' : 
        name === 'Map' ? '地图' : 
        name === 'Humiture' ? '温湿度' : ''
      },
      // 设置小屏
      settingSS () {
        vm.$router.push('/Dkb')
      }
    },
    watch: {
    }
  }
  
</script>

<style lang="scss" scoped>
.DkbFScreen {
  flex-shrink: 0;
  width: 12.18rem;
  height: 100%;
  background: url('/static/images/dkb/fs_bg.png') center no-repeat;
  background-size: 12.18rem 100%;
  position: relative;
  .fsTit {
    width: 2.44rem;
    font-size: 0.24rem;
    line-height: 0.35rem;
    letter-spacing: 0.05rem;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
  }
  .fsBtn {
    width: 0.2rem;
    height: 0.2rem;
    background: url('/static/images/dkb/dbtn_s.png') center no-repeat;
    background-size: 100%;
    position: absolute;
    right: 0.18rem;
    top: 0.16rem;
    z-index: 9;
  }
  .fsContent {
    // padding-top: 0.57rem;
    padding-top: 0.42rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/FScreen.vue